import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityDoc } from "../../entity/EntityDoc";

export class DtoDocsPutReq extends EntityDoc {
  public IsValid(): string[] {
    let res: string[] = new Array();
    //単項目チェック
    //--------------
    if (!commonRegx.isMatch(this.c_doc_id!.toString(), "^\\d+$", commonRegx._stdOption)) {
      res.push("type error");
    }

    return res;
  }
}
